import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private logData: string[] = [];

  log(message: string | object): void {
    const logEntry = this.formatLogEntry(message) + '\n';
    this.logData.push(logEntry);
  }

  private formatLogEntry(message: string | object): string {
    if (typeof message === 'string') {
      return message;
    } else {
      return JSON.stringify(message);
    }
  }

  saveLogToFile(): void {
    const logText = this.logData.join('\n');
    const file = new File([logText], 'logfile.txt');
    const anchor = document.createElement('a');
    anchor.href = URL.createObjectURL(file);
    anchor.download = file.name;
    anchor.click();
    URL.revokeObjectURL(anchor.href);
  }
}
